// Date ranges are sent with an explicit +05:30 offset. The hardcoded
// "+00:00" these replaced meant a day ran 05:30 IST to 05:29 IST the next
// morning, so a call placed before 05:30 landed in the previous day's report.
// (Measured: 0 of production's 271,959 calls fall in that window today -- the
// bug was real but had never yet bitten. It costs nothing to be right.)
export const IST_DAY_START = 'T00:00:00+05:30';
export const IST_DAY_END = 'T23:59:59+05:30';

export const DetailCallHistoryReportQuery = `
  query callHistoryReportQuery(
    $fromDate: DateTime,
    $toDate: DateTime,
    $retailerName: ID,
    $town: String,
    $area: ID,
    $state: ID,
    $after: String,
    $userId: ID
  ){
    allCallHistorys(
      retailer_Firm_Icontains: $retailerName,
      town: $town,
      workHistory_Area: $area,
      workHistory_Work_State: $state,
      callStart_Gte: $fromDate,
      callStart_Lte: $toDate,
      first: 20,
      after: $after,
      workHistory_Work_Caller: $userId
    ){
      pageInfo{
        endCursor
        hasNextPage
      }
      edges{
        node{
          id
          retailer{
            firm
          }
          callDate
          callStart
          duration
          mobileNumber
          callStatus
          workHistory{
            work{
              caller{
                employee{
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

// The caller whose name heads the drill-down page. Fetched separately so the
// title reads "Sandhya Rani" rather than the raw id -- and so an empty result
// set still knows whose report it is.
export const callerNameQuery = `
  query callerName($id: ID!){
    userDetail(id: $id){
      id
      employee{
        name
      }
    }
  }
`;

export const summarisedReportQuery = `
  query callSummarisedReport(
    $userId: ID,
    $dateRange: String!,
    $after: String
  ){
    allUserDetails(
      id: $userId,
      dateRange: $dateRange,
      after: $after,
      userType: "CALLER",
      first: 20
    ){
      pageInfo{
        endCursor
        hasNextPage
      }
      edges{
        node{
          id
          employee{
            name
            townid{
              name
            }
          }
          totalAssignment(dateRange: $dateRange)
          notAnswered(dateRange: $dateRange)
          wrongNumber(dateRange: $dateRange)
          callAnswered(dateRange: $dateRange)
          submitWithAlert(dateRange: $dateRange)
        }
      }
    }
  }
`;
